import { RefreshCw } from "lucide-react"
import { Button } from "@/components/ui/button"
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"
import { useTranslation } from "react-i18next"

type ErrorProps = {
  error: unknown
  message?: string
}

export const ErrorPage = ({ error, message }: ErrorProps) => {
  console.error(error)

  const dataPage = document.querySelector('script[data-page="app"][type="application/json"]')?.textContent
  if (dataPage) {
    console.error("Inertia data-page", JSON.parse(dataPage))
  }

  const { t } = useTranslation()
  const handleRefresh = () => {
    window.location.reload()
  }

  const displayMessage = message ?? t("apps.admin.error.message")

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-50 to-gray-200 p-4">
      <Card className="w-full max-w-md">
        <CardHeader>
          <CardTitle className="text-center text-2xl font-semibold text-gray-800">
            {t("apps.admin.error.title")}
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-6">
          <p className="text-center text-gray-600">{displayMessage}</p>
          <div className="flex justify-center">
            <Button onClick={handleRefresh} className="inline-flex items-center gap-2">
              <RefreshCw className="h-4 w-4" />
              {t("apps.admin.error.tryAgain")}
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  )
}
